<ejs-dashboardlayout
    [cellSpacing]='cellSpacing'
    [columns]="cellColumns"
    [allowDragging]="isEditMode"
    [allowPushing]="isEditMode"
    [allowResizing]='isEditMode'
    [showGridLines]='isEditMode'
    (resizeStop)="onResizeStop($event)"
    (change)="onChange($event)"
    (created)="onInitDashboard()">
</ejs-dashboardlayout>
<ng-container #viewContainer></ng-container>
<app-add-widget-dialog #addWidgetDialog (widgetSelected)="onSaveAddWidgetDialog($event)"></app-add-widget-dialog>
